export enum MyPortfolioViewEnum {
  All = 'all',
  Workstream = 'workstream',
  Project = 'project',
}

export enum MyPortfolioColumnsEnum {
  TaskName = 'taskName',
  TaskStatus = 'taskStatus',
  Action = 'action',
  DueDate = 'dueDate',
  DaysRemaining = 'daysRemaining',
  AssigneeName = 'assigneeName',
  AssigneeId = 'assigneeId',
  ProjectName = 'projectName',
  ProjectId = 'projectId',
  WorkstreamName = 'workstreamName',
  WorkstreamId = 'workstreamId',
  LoggedTime = 'loggedTime',
  ApproverName = 'approverName',
  ApproverId = 'approverId',
  ReviewerName = 'reviewerName',
  ReviewerId = 'reviewerId',
  StartDate = 'startDate',
  AdjustedDate = 'adjustedDate',
  ApplicableFrom = 'applicableFrom',
  ApplicableTo = 'applicableTo',
  DateCompleted = 'dateCompleted',
  Recurrence = 'recurrence',
  Tags = 'tags',
  IsMilestone = 'isMilestone',
  HasReport = 'hasReport',
}
